import { Suspense, useEffect, useState } from 'react';
import { Formik } from 'formik';
import CurrentRecruitingPipeLine from '../../components/CurrentRecruitingPipeLine';
import DashboardFunnel from '../../components/DashboardFunnel';
import RecruitersStatus from '../../components/RecruitersStatus';
import MultiSelectDropDown from '../../components/MultiselectDropdown/MultiselectDropdown';
import CloseSvg from '../../components/IconComponent';
import { useGetDashboardDetailsMutation } from '../../store/apiSlices/recruitApiSlice';
import { DropdownModel } from './../../models/dropdown.model';
import { Stage } from '../../enums/enum';

const DashboardSections = ({
	recruitingManagers,
	stageIds,
}: {
	recruitingManagers: DropdownModel[];
	stageIds: DropdownModel[];
}) => {
	const initialSelectedRMs: string[] = [];
	const initialStage: string = stageIds.find((e) => e.value === Stage.offer)
		?.id as string;
	const [selectedRMs, setSelectedRMs] =
		useState<string[]>(initialSelectedRMs);
	const heightExcludingNavbarAndPadding = 'calc( 100vh - 111px )';
	const dashboardComponentHeightExcludingNavPaddings = 'calc( 100vh - 143px)';
	const dashboardComponentMinHeight = {
		minHeight: heightExcludingNavbarAndPadding,
	};
	const dashboardSubComponentMinHeight = {
		height: dashboardComponentHeightExcludingNavPaddings,
	};
	const [dashboardData, updateDashboardData] =
		useGetDashboardDetailsMutation();

	const onRecruitingManagerSelect = (e: string[]) => {
		setSelectedRMs(e);
	};

	useEffect(() => {
		dashboardData({
			recruiting_manager_ids: initialSelectedRMs,
			stage_id: stageIds.find((e) => e.value === Stage.offer)
				?.id as string,
		});
	}, []);

	const handleStages = (val: DropdownModel) => {
		dashboardData({
			recruiting_manager_ids: selectedRMs,
			stage_id: val.id,
		});
	};

	const handleClear = () => {
		setSelectedRMs(initialSelectedRMs);
	};

	return (
		<Formik
			initialValues={{
				recruiting_manager_ids: initialSelectedRMs,
				stageId: initialStage,
			}}
			enableReinitialize
			onSubmit={(val) =>
				dashboardData({
					recruiting_manager_ids: val.recruiting_manager_ids,
					stage_id: val.stageId,
				})
			}
		>
			{({ handleSubmit, getFieldHelpers }) => (
				<div
					style={dashboardComponentMinHeight}
					className="flex flex-col p-4 gap-4"
				>
					<div className="flex bg-white p-4 justify-between items-center">
						<div className="font-semibold">Dashboard</div>
						<div className="flex items-center gap-x-4 min-w-[450px]">
							<div className="font-semibold">Showing</div>
							<Suspense fallback="loading...">
								{recruitingManagers?.length ? (
									<MultiSelectDropDown
										name="recruiting_manager_ids"
										options={
											recruitingManagers?.length
												? (recruitingManagers as DropdownModel[])
												: []
										}
										onOptionChange={(val) => {
											onRecruitingManagerSelect(val);
											handleSubmit();
										}}
										_selectedFilters={
											selectedRMs?.filter(
												(x: string) => x != '',
											) ?? []
										}
										minSelectedItemsToShow={1}
										isAllCheckRequired={false}
										customMessageForSelectAll="All Recruits"
										customMessageForDeselectAll="All Recruits"
										showListOnSelectAll={false}
										selectedItemClassName="max-w-[160px]"
										childContainerClassName="rounded-lg border-2 border-rcrm-primary-border-blue"
									/>
								) : null}
								<button
									className="flex items-center gap-x-2"
									disabled={!selectedRMs?.length}
									onClick={() => {
										handleClear();
										getFieldHelpers(
											'recruiting_manager_ids',
										).setValue(initialSelectedRMs);
										handleSubmit();
									}}
								>
									<CloseSvg
										svgClassName="w-4 h-4"
										pathClassName={`${selectedRMs?.length ? 'fill-rcrm-primary-red hover:fill-rcrm-hover-red' : 'fill-rcrm-disabled-button'}`}
									/>
									<p
										className={`whitespace-nowrap font-semibold ${selectedRMs?.length ? 'text-rcrm-primary-red hover:text-rcrm-hover-red' : 'text-rcrm-disabled-button'}`}
									>
										Clear All
									</p>
								</button>
							</Suspense>
						</div>
					</div>
					<div className="flex gap-4 xl:flex-row max-lg:flex-col">
						<div
							className={` rounded-lg lg:basis-1/2 basis-full flex flex-col gap-4`}
							style={dashboardSubComponentMinHeight}
						>
							<div className="h-[25%]  flex gap-4">
								<div className="basis-1/2 bg-white rounded-lg p-2">
									{
										<RecruitersStatus
											isActive={true}
											count={
												updateDashboardData.data?.value
													.active_recruiters!
											}
										/>
									}
								</div>
								<div className="basis-1/2 bg-white rounded-lg p-2">
									{
										<RecruitersStatus
											isActive={false}
											count={
												updateDashboardData.data?.value
													?.inactive_recruiters!
											}
										/>
									}
								</div>
							</div>
							<div className="h-[75%] bg-white rounded-lg p-4">
								{
									<DashboardFunnel
										recruitingFunnel={
											updateDashboardData.data?.value
												?.recruiting_funnel!
										}
									/>
								}
							</div>
						</div>
						<div
							className="rounded-lg bg-white lg:basis-1/2 lg:w-1/2 basis-full p-4"
							style={dashboardSubComponentMinHeight}
						>
							{
								<CurrentRecruitingPipeLine
									recruitPipeLineData={
										updateDashboardData.data?.value
											?.recruiting_pipeline
									}
									stageIds={stageIds}
									handleStages={handleStages}
								/>
							}
						</div>
					</div>
				</div>
			)}
		</Formik>
	);
};
export default DashboardSections;
